export const translations = {
  pt: {
    nav: {
      home: "Início",
      about: "Sobre Nós",
      products: "Produtos",
      solutions: "Soluções",
      agribusiness: "Agronegócio",
      contact: "Contacto",
      requestQuote: "Pedir Cotação",
    },
    hero: {
      badge: "Agronegócio · Angola & Namíbia",
      title1: "Conectando o Agronegócio.",
      title2: "Criando Oportunidades.",
      subtitle:
        "A AgroLink conecta produtos agrícolas, insumos, nutrição animal e oportunidades de mercado através de parcerias confiáveis e soluções eficientes.",
      ctaProducts: "Explorar Produtos",
      ctaQuote: "Pedir Cotação",
      trust: "Conexões confiáveis em toda a cadeia de valor agrícola",
    },
    valueProps: {
      label: "O QUE FAZEMOS",
      title: "Soluções em toda a cadeia agrícola",
      items: [
        { title: "Insumos Agrícolas", desc: "Sementes, fertilizantes, proteção de culturas e outros insumos essenciais." },
        { title: "Ração Animal", desc: "Soluções de nutrição de qualidade para pecuária e produção animal." },
        { title: "Produtos Agrícolas", desc: "Conectamos produtores e clientes com produtos agrícolas de qualidade." },
        { title: "Conexões Confiáveis", desc: "Relações de confiança entre fornecedores, produtores e mercados." },
      ],
    },
    about: {
      label: "SOBRE A AGROLINK",
      title: "Conectando a Cadeia de Valor Agrícola",
      p1: "A AgroLink existe para conectar produtores agrícolas, fornecedores, empresas e mercados através de produtos confiáveis, serviço profissional e parcerias sólidas.",
      p2: "Compreendemos o ecossistema agrícola de ponta a ponta — do fornecedor ao produto, da logística ao cliente e ao mercado — e trabalhamos para que cada ligação crie valor duradouro.",
      chain: ["Fornecedor", "Produto", "Logística", "Cliente", "Mercado"],
      learnMore: "Conheça a AgroLink",
      stats: [
        { value: "2", label: "Países de operação" },
        { value: "4", label: "Categorias de produtos" },
        { value: "100%", label: "Foco no cliente" },
      ],
    },
    mvv: {
      label: "A NOSSA ESSÊNCIA",
      title: "Missão, Visão e Valores",
      mission: "Missão",
      missionText:
        "Conectar pessoas, produtos e oportunidades em toda a cadeia de valor agrícola, entregando soluções confiáveis e valor duradouro.",
      vision: "Visão",
      visionText:
        "Ser um parceiro de agronegócio de confiança, conectando mercados agrícolas locais e internacionais.",
      values: "Valores",
      valuesList: ["Integridade", "Qualidade", "Confiabilidade", "Parceria", "Inovação", "Sustentabilidade"],
    },
    products: {
      label: "OS NOSSOS PRODUTOS",
      title: "Soluções para a Cadeia de Valor Agrícola",
      subtitle: "Explore as nossas categorias de produtos — de insumos agrícolas a nutrição animal e commodities.",
      viewAll: "Ver Todos os Produtos",
      viewProduct: "Ver Produto",
      requestQuote: "Pedir Cotação",
      featured: "Produtos em Destaque",
      searchPlaceholder: "Pesquisar produtos...",
      allCategories: "Todas as Categorias",
      category: "Categoria",
      availability: "Disponibilidade",
      allAvailability: "Todas",
      inStock: "Em Stock",
      onRequest: "Sob Consulta",
      noResults: "Nenhum produto corresponde aos seus filtros.",
      resetFilters: "Limpar Filtros",
      resultsCount: "produtos encontrados",
      pageTitle: "Catálogo de Produtos",
      pageSubtitle: "Produtos agrícolas, insumos, nutrição animal e equipamentos — organizados para facilitar a sua pesquisa.",
    },
    productDetail: {
      description: "Descrição",
      applications: "Aplicações",
      packaging: "Embalagem",
      specifications: "Especificações",
      availability: "Disponibilidade",
      requestQuote: "Pedir Cotação",
      backToProducts: "Voltar aos Produtos",
      related: "Produtos Relacionados",
      inStock: "Em Stock",
      onRequest: "Sob Consulta",
      notFound: "Produto não encontrado",
      notFoundDesc: "O produto que procura não existe ou foi removido.",
    },
    solutions: {
      label: "SOLUÇÕES",
      title: "Soluções que Fazem a Agricultura Avançar",
      subtitle: "Apoiamos diferentes clientes em toda a cadeia de valor agrícola.",
      items: [
        { title: "Para Agricultores", desc: "Acesso confiável a insumos agrícolas e nutrição animal." },
        { title: "Para Agroindústrias", desc: "Soluções de sourcing e fornecimento de produtos." },
        { title: "Para Fornecedores", desc: "Acesso a novos clientes e mercados." },
        { title: "Para Comerciantes", desc: "Conexões confiáveis de produtos agrícolas." },
        { title: "Para Produtores", desc: "Produtos de qualidade e fornecimento fiável." },
      ],
      pageTitle: "Soluções AgroLink",
    },
    process: {
      label: "COMO FUNCIONA",
      title: "Como a AgroLink Trabalha",
      steps: [
        { num: "01", title: "Entender", desc: "Entendemos a sua necessidade agrícola ou de fornecimento." },
        { num: "02", title: "Conectar", desc: "Conectamos você ao produto ou fornecedor adequado." },
        { num: "03", title: "Fornecer", desc: "Coordenamos o processo comercial e o fornecimento." },
        { num: "04", title: "Crescer", desc: "Construímos relações de longo prazo que criam valor sustentável." },
      ],
    },
    why: {
      label: "PORQUÊ A AGROLINK",
      title: "Porquê Trabalhar Com a AgroLink?",
      items: [
        { title: "Conexões Confiáveis", desc: "Relações sólidas em todo o ecossistema agrícola." },
        { title: "Foco na Qualidade", desc: "Produtos e parceiros selecionados com a qualidade em mente." },
        { title: "Conhecimento de Mercado", desc: "Compreensão dos produtos agrícolas e das necessidades do mercado." },
        { title: "Serviço Fiável", desc: "Comunicação profissional do pedido à entrega." },
        { title: "Soluções Flexíveis", desc: "Soluções adaptadas a diferentes clientes e necessidades." },
        { title: "Parcerias Duradouras", desc: "Foco em relações e não em transações pontuais." },
      ],
    },
    sectors: {
      label: "SETORES",
      title: "Servindo Diferentes Áreas da Agricultura",
      items: [
        { title: "Produção Vegetal", desc: "Culturas de cereais, hortícolas e produção comercial." },
        { title: "Pecuária", desc: "Bovinos de carne e leite, pequenos ruminantes." },
        { title: "Avicultura", desc: "Frangos de corte, poedeiras e produção familiar." },
        { title: "Nutrição Animal", desc: "Rações, concentrados e suplementos minerais." },
        { title: "Insumos Agrícolas", desc: "Sementes, fertilizantes e proteção de culturas." },
        { title: "Agronegócio e Comércio", desc: "Commodities, logística e ligações de mercado." },
      ],
    },
    partners: {
      label: "PARCEIROS",
      title: "Construído Sobre Parcerias Sólidas",
      subtitle: "Trabalhamos com fornecedores e parceiros selecionados em toda a cadeia de valor.",
      placeholder: "O seu logótipo aqui",
      cta: "Torne-se Parceiro",
    },
    network: {
      label: "A NOSSA REDE",
      title: "Conectamos os Produtos Certos às Oportunidades Certas.",
      subtitle: "O nome AgroLink representa a nossa missão: ser o elo de ligação em todo o agronegócio.",
      nodes: ["Agricultores", "Fornecedores", "Produtos", "Logística", "Mercados"],
    },
    cta: {
      title: "Procura um Produto Agrícola ou uma Solução de Fornecimento?",
      subtitle: "Diga-nos o que precisa e a nossa equipa irá ajudá-lo a encontrar a solução certa.",
      quote: "Pedir Cotação",
      contact: "Contactar a AgroLink",
    },
    contact: {
      label: "CONTACTO",
      title: "Fale Connosco",
      subtitle: "Preencha o formulário e a nossa equipa responderá o mais breve possível.",
      formTitle: "Pedido de Cotação",
      fullName: "Nome Completo",
      company: "Empresa",
      email: "Email",
      phone: "Telefone / WhatsApp",
      country: "País",
      productInterest: "Produto / Serviço de Interesse",
      quantity: "Quantidade / Necessidade",
      message: "Mensagem",
      submit: "Enviar Pedido",
      submitting: "A enviar...",
      success: "Pedido enviado com sucesso! Entraremos em contacto em breve.",
      error: "Ocorreu um erro ao enviar. Tente novamente.",
      required: "Campo obrigatório",
      invalidEmail: "Email inválido",
      whatsappTitle: "Fale no WhatsApp",
      whatsappAngola: "WhatsApp Angola",
      whatsappNamibia: "WhatsApp Namíbia",
      branches: "Os Nossos Escritórios",
      angolaBranch: "Sucursal de Angola",
      namibiaBranch: "Sucursal da Namíbia",
      emailTitle: "Email",
      selectProduct: "Selecione um produto (opcional)",
      generalEnquiry: "Consulta geral",
      countryPlaceholder: "ex.: Angola, Namíbia...",
      quantityPlaceholder: "ex.: 200 sacos de 50 kg",
      messagePlaceholder: "Descreva a sua necessidade...",
    },
    team: {
      label: "A NOSSA EQUIPA",
      title: "As Pessoas Por Trás da AgroLink",
      subtitle: "Uma equipa dedicada a conectar a agricultura com oportunidades.",
    },
    footer: {
      tagline: "Conectando agricultura, produtos e oportunidades.",
      navigation: "Navegação",
      contact: "Contacto",
      legal: "Legal",
      privacy: "Política de Privacidade",
      terms: "Termos e Condições",
      rights: "Todos os direitos reservados.",
      language: "Idioma",
    },
    aboutPage: {
      heroLabel: "SOBRE NÓS",
      heroTitle: "Somos o Elo de Ligação do Agronegócio",
      heroSubtitle: "Conheça a empresa, a nossa missão e a equipa que faz a AgroLink acontecer.",
      storyLabel: "A NOSSA HISTÓRIA",
      storyTitle: "Do Fornecedor ao Mercado, Criamos Ligações que Geram Valor",
      storyP1: "A AgroLink nasceu com um propósito claro: aproximar quem produz de quem precisa, com profissionalismo e confiança.",
      storyP2: "Operamos entre Angola e Namíbia, conectando insumos agrícolas, nutrição animal, produtos e equipamentos aos clientes certos — com um serviço próximo e orientado a resultados.",
    },
    agriPage: {
      heroLabel: "AGRONEGÓCIO",
      heroTitle: "Ligamos Mercados, Produtos e Pessoas",
      heroSubtitle: "Da produção à comercialização, a AgroLink atua em toda a cadeia do agronegócio.",
    },
    misc: {
      loading: "A carregar...",
      seeMore: "Ver mais",
      home: "Início",
      adminLogin: "Área de Administração",
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About Us",
      products: "Products",
      solutions: "Solutions",
      agribusiness: "Agribusiness",
      contact: "Contact",
      requestQuote: "Request a Quote",
    },
    hero: {
      badge: "Agribusiness · Angola & Namibia",
      title1: "Connecting Agriculture.",
      title2: "Creating Opportunities.",
      subtitle:
        "AgroLink connects agricultural products, inputs, animal nutrition and market opportunities through trusted partnerships and reliable solutions.",
      ctaProducts: "Explore Our Products",
      ctaQuote: "Request a Quote",
      trust: "Trusted connections across the agricultural value chain",
    },
    valueProps: {
      label: "WHAT WE DO",
      title: "Solutions across the agricultural chain",
      items: [
        { title: "Agricultural Inputs", desc: "Seeds, fertilizers, crop protection and other agricultural essentials." },
        { title: "Animal Feed", desc: "Quality nutrition solutions for livestock and animal production." },
        { title: "Agricultural Products", desc: "Connecting producers and customers with agricultural products." },
        { title: "Reliable Connections", desc: "Building trusted relationships between suppliers, producers and markets." },
      ],
    },
    about: {
      label: "ABOUT AGROLINK",
      title: "Connecting the Agricultural Value Chain",
      p1: "AgroLink exists to connect agricultural producers, suppliers, businesses and markets through reliable products, professional service and strong partnerships.",
      p2: "We understand the agricultural ecosystem end to end — from supplier to product, logistics to customer and market — and we work to make every link create lasting value.",
      chain: ["Supplier", "Product", "Logistics", "Customer", "Market"],
      learnMore: "Learn About AgroLink",
      stats: [
        { value: "2", label: "Countries of operation" },
        { value: "4", label: "Product categories" },
        { value: "100%", label: "Customer focus" },
      ],
    },
    mvv: {
      label: "OUR ESSENCE",
      title: "Mission, Vision & Values",
      mission: "Mission",
      missionText:
        "To connect people, products and opportunities across the agricultural value chain while delivering reliable solutions and lasting value.",
      vision: "Vision",
      visionText:
        "To become a trusted agribusiness partner connecting local and international agricultural markets.",
      values: "Values",
      valuesList: ["Integrity", "Quality", "Reliability", "Partnership", "Innovation", "Sustainability"],
    },
    products: {
      label: "OUR PRODUCTS",
      title: "Solutions for the Agricultural Value Chain",
      subtitle: "Explore our product categories — from agricultural inputs to animal nutrition and commodities.",
      viewAll: "View All Products",
      viewProduct: "View Product",
      requestQuote: "Request Quote",
      featured: "Featured Products",
      searchPlaceholder: "Search products...",
      allCategories: "All Categories",
      category: "Category",
      availability: "Availability",
      allAvailability: "All",
      inStock: "In Stock",
      onRequest: "On Request",
      noResults: "No products match your filters.",
      resetFilters: "Reset Filters",
      resultsCount: "products found",
      pageTitle: "Product Catalog",
      pageSubtitle: "Agricultural products, inputs, animal nutrition and equipment — organized to make your search easy.",
    },
    productDetail: {
      description: "Description",
      applications: "Applications",
      packaging: "Packaging",
      specifications: "Specifications",
      availability: "Availability",
      requestQuote: "Request a Quote",
      backToProducts: "Back to Products",
      related: "Related Products",
      inStock: "In Stock",
      onRequest: "On Request",
      notFound: "Product not found",
      notFoundDesc: "The product you are looking for does not exist or has been removed.",
    },
    solutions: {
      label: "SOLUTIONS",
      title: "Solutions That Move Agriculture Forward",
      subtitle: "We support different customers across the agricultural value chain.",
      items: [
        { title: "For Farmers", desc: "Reliable access to agricultural inputs and animal nutrition." },
        { title: "For Agribusinesses", desc: "Product sourcing and supply solutions." },
        { title: "For Suppliers", desc: "Access to new customers and markets." },
        { title: "For Traders", desc: "Reliable agricultural product connections." },
        { title: "For Producers", desc: "Quality products and dependable supply." },
      ],
      pageTitle: "AgroLink Solutions",
    },
    process: {
      label: "HOW IT WORKS",
      title: "How AgroLink Works",
      steps: [
        { num: "01", title: "Understand", desc: "We understand your agricultural or supply requirement." },
        { num: "02", title: "Connect", desc: "We connect you with the appropriate product or supplier." },
        { num: "03", title: "Supply", desc: "We coordinate the commercial process and supply." },
        { num: "04", title: "Grow", desc: "We build long-term relationships that create sustainable value." },
      ],
    },
    why: {
      label: "WHY AGROLINK",
      title: "Why Partner With AgroLink?",
      items: [
        { title: "Trusted Connections", desc: "Strong relationships across the agricultural ecosystem." },
        { title: "Quality Focus", desc: "Products and partners selected with quality in mind." },
        { title: "Market Knowledge", desc: "Understanding of agricultural products and market needs." },
        { title: "Reliable Service", desc: "Professional communication from enquiry to delivery." },
        { title: "Flexible Solutions", desc: "Solutions adapted to different customers and requirements." },
        { title: "Long-Term Partnerships", desc: "Focused on relationships rather than one-off transactions." },
      ],
    },
    sectors: {
      label: "SECTORS",
      title: "Serving Different Areas of Agriculture",
      items: [
        { title: "Crop Production", desc: "Cereal crops, vegetables and commercial production." },
        { title: "Livestock", desc: "Beef and dairy cattle, small ruminants." },
        { title: "Poultry", desc: "Broilers, layers and family production." },
        { title: "Animal Nutrition", desc: "Feeds, concentrates and mineral supplements." },
        { title: "Agricultural Inputs", desc: "Seeds, fertilizers and crop protection." },
        { title: "Agribusiness & Trading", desc: "Commodities, logistics and market connections." },
      ],
    },
    partners: {
      label: "PARTNERS",
      title: "Built on Strong Partnerships",
      subtitle: "We work with selected suppliers and partners across the value chain.",
      placeholder: "Your logo here",
      cta: "Become a Partner",
    },
    network: {
      label: "OUR NETWORK",
      title: "We Connect the Right Products With the Right Opportunities.",
      subtitle: "The name AgroLink represents our mission: to be the connection point across agribusiness.",
      nodes: ["Farmers", "Suppliers", "Products", "Logistics", "Markets"],
    },
    cta: {
      title: "Looking for an Agricultural Product or Supply Solution?",
      subtitle: "Tell us what you need and our team will help connect you with the right solution.",
      quote: "Request a Quote",
      contact: "Contact AgroLink",
    },
    contact: {
      label: "CONTACT",
      title: "Get in Touch",
      subtitle: "Fill in the form and our team will get back to you as soon as possible.",
      formTitle: "Request a Quote",
      fullName: "Full Name",
      company: "Company",
      email: "Email",
      phone: "Phone / WhatsApp",
      country: "Country",
      productInterest: "Product / Service Interested In",
      quantity: "Quantity / Requirement",
      message: "Message",
      submit: "Submit Request",
      submitting: "Submitting...",
      success: "Request submitted successfully! We will contact you soon.",
      error: "An error occurred while submitting. Please try again.",
      required: "Required field",
      invalidEmail: "Invalid email",
      whatsappTitle: "Chat on WhatsApp",
      whatsappAngola: "WhatsApp Angola",
      whatsappNamibia: "WhatsApp Namibia",
      branches: "Our Offices",
      angolaBranch: "Angola Branch",
      namibiaBranch: "Namibia Branch",
      emailTitle: "Email",
      selectProduct: "Select a product (optional)",
      generalEnquiry: "General enquiry",
      countryPlaceholder: "e.g. Angola, Namibia...",
      quantityPlaceholder: "e.g. 200 bags of 50 kg",
      messagePlaceholder: "Describe your requirement...",
    },
    team: {
      label: "OUR TEAM",
      title: "The People Behind AgroLink",
      subtitle: "A team dedicated to connecting agriculture with opportunity.",
    },
    footer: {
      tagline: "Connecting agriculture, products and opportunities.",
      navigation: "Navigation",
      contact: "Contact",
      legal: "Legal",
      privacy: "Privacy Policy",
      terms: "Terms & Conditions",
      rights: "All rights reserved.",
      language: "Language",
    },
    aboutPage: {
      heroLabel: "ABOUT US",
      heroTitle: "We Are the Connection Point of Agribusiness",
      heroSubtitle: "Get to know the company, our mission and the team that makes AgroLink happen.",
      storyLabel: "OUR STORY",
      storyTitle: "From Supplier to Market, We Create Connections That Generate Value",
      storyP1: "AgroLink was born with a clear purpose: to bring together those who produce and those who need, with professionalism and trust.",
      storyP2: "We operate between Angola and Namibia, connecting agricultural inputs, animal nutrition, products and equipment to the right customers — with a close, results-oriented service.",
    },
    agriPage: {
      heroLabel: "AGRIBUSINESS",
      heroTitle: "We Link Markets, Products and People",
      heroSubtitle: "From production to trade, AgroLink operates across the entire agribusiness chain.",
    },
    misc: {
      loading: "Loading...",
      seeMore: "See more",
      home: "Home",
      adminLogin: "Admin Area",
    },
  },
};
